export function getMaxHeight(bookOpen: boolean, screenSize: string) {
    if (!bookOpen) return '60vh';
    if (screenSize === 'md') return '8vh';
    if (['lg', 'xl'].includes(screenSize)) return '31vh';
}
